import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Plays from './liveFeed/LiveFeedPlays';
import { LiveFeedWrapper, LiveFeedList } from './LiveFeed.style';
import { makeInningHeader } from '../PlayFeed/PlayFeed';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import getInningTranslations from '../PlayFeed/utils/translatedInnings';
import LiveFeedPromos from './LiveFeedPromos';

const LiveFeed = ({
    playsByInning = [],
    teams,
    reverseChron = true,
    isLoading = false,
    showAllPitches = false,
    showAnimations = false,
    openAtBatOverlay,
    showBasesText
}) => {
    const playsProps = {
        teams,
        offset: true,
        reverseChron,
        showAllPitches,
        showAnimations,
        openAtBatOverlay,
        showBasesText
    };

    const topText = useTranslator('game_status_top', 'Top');
    const bottomText = useTranslator('game_status_bottom', 'Bottom');
    const inningTranslations = getInningTranslations();
    const orderedPlaysByInning = reverseChron ? [...playsByInning].reverse() : playsByInning;

    return (
        <LiveFeedWrapper
        >
            <LiveFeedList
                reverse={reverseChron}
                $hasList={orderedPlaysByInning.length > 0}
            >
                {
                    orderedPlaysByInning.map((playsObj, i) => {
                        const inning = reverseChron ? orderedPlaysByInning.length - i : i + 1;
                        const {
                            top = [],
                            bottom = []
                        } = playsObj;
                        const inningTranslation = inningTranslations[inning];

                        const topDiv = top.length ? makeInningHeader(topText, inningTranslation, isLoading, 1) : null;
                        const bottomDiv = bottom.length ? makeInningHeader(bottomText, inningTranslation, isLoading, 1) : null;

                        return (<Fragment key={`inning-${inning}`}>
                            { !reverseChron && <LiveFeedPromos inning={inning} type={'feed'} pos={'bottom'} />}
                            { reverseChron ? bottomDiv : topDiv }
                            <Plays playArr={ reverseChron ? bottom : top } {...playsProps} />
                            {reverseChron && <LiveFeedPromos inning={inning} type={'feed'} pos={'bottom'} />}
                            { reverseChron ? topDiv : bottomDiv }
                            <Plays playArr={ reverseChron ? top : bottom } {...playsProps} />
                            {reverseChron && <LiveFeedPromos inning={inning} type={'feed'} pos={'top'} />}
                        </Fragment>);
                    })
                }
            </LiveFeedList>
        </LiveFeedWrapper>
    );
};

LiveFeed.propTypes = {
    openAtBatOverlay: PropTypes.func,
    playsByInning: PropTypes.arrayOf(PropTypes.object),
    teams: PropTypes.object,
    reverseChron: PropTypes.bool,
    isLoading: PropTypes.bool,
    showAllPitches: PropTypes.bool,
    showAnimations: PropTypes.bool,
    showBasesText: PropTypes.bool
};

export default LiveFeed;
